import { useState } from 'react';
import { Icon } from './Icon';
import { CTAS } from '../content/site';

const NAV_LINKS = [
  { label: 'Partnership types', href: '#partnership-types' },
  { label: 'Benefits', href: '#benefits' },
  { label: 'Campaign examples', href: '#examples' },
  { label: 'How it works', href: '#how-it-works' },
  { label: 'FAQ', href: '#faq' },
];

export function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-line/70 bg-white/90 backdrop-blur">
      <nav className="container-content flex h-16 items-center justify-between" aria-label="Primary">
        <a href="#top" className="flex items-center gap-2 font-heading text-lg font-bold text-ink-900">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-aurora text-white">
            <Icon name="trophy" className="h-5 w-5" />
          </span>
          <span>
            Corporate <span className="text-aurora">Partnerships</span>
          </span>
        </a>

        <div className="hidden items-center gap-8 md:flex">
          <ul className="flex items-center gap-6">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="font-heading text-sm font-medium text-ink-700 transition-colors hover:text-primary-700"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="/partner/login"
            className="font-heading text-sm font-medium text-ink-700 transition-colors hover:text-primary-700"
          >
            Partner login
          </a>
          <a
            href="/admin/login"
            className="font-heading text-sm font-medium text-ink-500 transition-colors hover:text-primary-700"
          >
            Staff
          </a>
          <a href={CTAS.bookCall.href} className="btn-secondary px-4 py-2 text-sm">
            {CTAS.bookCall.label}
          </a>
          <a href={CTAS.sponsorPrize.href} className="btn-primary px-4 py-2 text-sm">
            {CTAS.sponsorPrize.label}
          </a>
        </div>

        <button
          type="button"
          className="grid h-10 w-10 place-items-center rounded-lg text-ink-900 hover:bg-surface-muted md:hidden cursor-pointer"
          aria-expanded={open}
          aria-controls="mobile-menu"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((v) => !v)}
        >
          <Icon name={open ? 'close' : 'menu'} className="h-6 w-6" />
        </button>
      </nav>

      {open && (
        <div id="mobile-menu" className="border-t border-line bg-white md:hidden">
          <ul className="container-content flex flex-col gap-1 py-4">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="block rounded-lg px-3 py-3 font-heading text-base font-medium text-ink-700 hover:bg-surface-muted"
                  onClick={() => setOpen(false)}
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="/partner/login"
                className="block rounded-lg px-3 py-3 font-heading text-base font-medium text-ink-700 hover:bg-surface-muted"
                onClick={() => setOpen(false)}
              >
                Partner login
              </a>
            </li>
            <li>
              <a
                href="/admin/login"
                className="block rounded-lg px-3 py-3 font-heading text-base font-medium text-ink-500 hover:bg-surface-muted"
                onClick={() => setOpen(false)}
              >
                Staff login
              </a>
            </li>
            <li className="mt-2 flex flex-col gap-2">
              <a href={CTAS.bookCall.href} className="btn-secondary w-full" onClick={() => setOpen(false)}>
                {CTAS.bookCall.label}
              </a>
              <a href={CTAS.sponsorPrize.href} className="btn-primary w-full" onClick={() => setOpen(false)}>
                {CTAS.sponsorPrize.label}
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}

export default Navbar;
